<script lang="ts">
    import KpSearchHeader from '../kp-search-header/KpSearchHeader.svelte';
    import KpSearchResultInfo from '../kp-search-result-info/KpSearchResultInfo.svelte';
    import type {SearchManager} from '../search-manager/search-manager';
    import KpSearchFooter from '../kp-search-footer/KpSearchFooter.svelte';
    import KpSearchSideContent from '../kp-search-content-layouts/KpSearchSideContent.svelte';
    import KpSearchMainContent from '../kp-search-content-layouts/KpSearchMainContent.svelte';
    import KpSearchResultsExportButton from '../kp-search-footer/KpSearchResultsExportButton.svelte';

    export let searchManager: SearchManager<any>;

    $: lastSearch = searchManager.getLastSearch$();
</script>

<div class="kp-search type-{$lastSearch?.type ?? ''}">
    <KpSearchHeader {searchManager}/>
    <KpSearchResultInfo {searchManager}/>

    <div class="row">
        <div class="col-sm-8">
            <KpSearchMainContent {searchManager}/>
        </div>
        <div class="col-sm-4">
            <KpSearchSideContent {searchManager}/>
        </div>
    </div>

    <KpSearchFooter {searchManager}>
        <KpSearchResultsExportButton availableExports={$lastSearch.availableExports}/>
    </KpSearchFooter>
</div>

<style lang="less">
    .row {
        margin-bottom: 30px;
    }
</style>